import { render, staticRenderFns } from "./TagsCategoryInstanceEdit.vue?vue&type=template&id=e74c9556&"
import script from "./TagsCategoryInstanceEdit.vue?vue&type=script&lang=js&"
export * from "./TagsCategoryInstanceEdit.vue?vue&type=script&lang=js&"
import style0 from "./TagsCategoryInstanceEdit.vue?vue&type=style&index=0&id=e74c9556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports